import {Configuration} from './generated';
import { toast } from "sonner";
import axios from "axios";

// Extend the Window interface to include our custom property
declare global {
    interface Window {
        lastAxiosErrorResponse?: {
            data: {
                message:string
            }
        };
    }
}

// Add Axios response interceptor to capture error responses globally
if (typeof window !== "undefined") {
    axios.interceptors.response.use(
        response => response,
        error => {
            if (error && error.response) {
                window.lastAxiosErrorResponse = error.response;
            }
            return Promise.reject(error);
        }
    );
}

// Get base path for API configuration
const getBasePath = (): string | undefined => {
    // If environment variable is set, use it as highest priority
    if (process.env.NEXT_PUBLIC_API_BASE_PATH) {
        return process.env.NEXT_PUBLIC_API_BASE_PATH;
    }
    
    // Check if we're in a browser environment
    if (typeof window !== 'undefined') {
        // If user has manually set an API endpoint in localStorage, use that
        const storedEndpoint = localStorage.getItem("API_ENDPOINT");
        if (storedEndpoint) {
            return storedEndpoint;
        }
        
        // If hostname contains 'uat' or we're not in production, use UAT API
        if (window.location.hostname.includes('uat') || process.env.NODE_ENV !== 'production') {
            return 'https://api.uat.meersec.com';
        }
    }
    
    // Default fallback
    return undefined;
};

// Configuration for unauthenticated requests (login, public endpoints)
export const getUnauthenticatedApiConfig = (): Configuration => {
    const basePath = getBasePath();
    console.log('[Unauthenticated API Config]', basePath);
    
    return new Configuration({
        basePath: basePath,
        baseOptions: {
            validateStatus: function (status: number) {
                if (status >= 200 && status < 300) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    });
};

// Configuration for authenticated requests (protected endpoints)
export const getApiConfig = (): Configuration | undefined => {
    const apiKey: string = typeof window !== 'undefined' ? localStorage.getItem("API_KEY") || "" : "";

    if (apiKey === "") {
        return undefined;
    }

    const basePath = getBasePath();
    console.log('[Authenticated API Config]', basePath);
    
    return new Configuration({
        basePath: basePath,
        accessToken: apiKey,
        baseOptions: {
            validateStatus: function (status: number) {
                if (status >= 200 && status < 300) {
                    return true;
                } else {
                    // Try to get the error message from the last Axios response
                    if (typeof window !== "undefined") {
                        // Use Axios global last response if available
                        const lastResponse = window.lastAxiosErrorResponse;
                        console.log(lastResponse)
                        if (lastResponse && lastResponse.data && lastResponse.data.message) {
                            toast.error(lastResponse.data.message);
                        } else {
                            toast.error("Error: " + lastResponse);
                        }
                    }
                    console.log('[API Error]', status);
                    return false;
                }
            },
        },
    });
};

export function getAuthStatus(): boolean {
    return typeof window !== 'undefined' ? localStorage.getItem("API_KEY") !== null : false;
}